import { Bonus } from '../../../../../../types/bonus';
import { useCreateReaction } from './use-create-reaction';
import { useRemoveReaction } from './use-remove-reaction';
import { useReplaceReaction } from './use-replace-reaction';

export const useReactionMutations = (bonus: Bonus) => {
	const create = useCreateReaction(bonus);
	const remove = useRemoveReaction(bonus);
	const replace = useReplaceReaction(bonus);

	return {
		createReaction: create.mutate,
		removeReaction: remove.mutate,
		replaceReaction: replace.mutate,
		isLoading: create.isLoading || remove.isLoading || replace.isLoading,
	};
};
